module.exports = __webpack_public_path__ + "assets/img/247201.ff275e34.png";